import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { AIButtonIconGradientIdPrefix } from '../AIButton.constants'
import { AIButtonIcon } from '../AIButtonIcon'

import * as styles from './AIButtonIconFlat.module.css'

function AIButtonIconFlat({
  Icon,
  beforeIconProps,
  className = styles.aiButtonIconFlat,
  height = BUTTON_HEIGHT_32,
  isLoading,
  ...restProps
}) {
  return (
    <AIButtonIcon
      {...restProps}
      Button={Button.Flat}
      Icon={Icon}
      beforeIconProps={beforeIconProps}
      className={className}
      gradientIdPrefix={AIButtonIconGradientIdPrefix.IconFlat}
      height={height}
      isLoading={isLoading}
    />
  )
}

export default AIButtonIconFlat
